export const GET_BRICS_EVENTS = 'GET_BRICS_EVENTS';
export const GET_BRICS_TRACKS = 'GET_BRICS_TRACKS';
export const GET_BRICS_WORKGROUPS = 'GET_BRICS_WORKGROUPS';
export const GET_BRICS_CITIES = 'GET_BRICS_CITIES';
